import React, {Component} from "react";
import Section from "./../layouts/Section";
import {Link} from "react-router-dom";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';

class Employeelist extends Component {
    constructor(props) {
        super(props);
        this.state={
          user_list:[],
          group_list:[],
          total_record:'',
          group_id: '*'
        }
    }
    componentDidMount(){
        this.getUserList('*');
        this.getAllGroups();  
    }

    getUserList(groupId){
        var user_id= localStorage.getItem('userid');
        var formData = new FormData();
        formData.append("user_id",user_id);
        formData.append("group_id",groupId);
        post(Constent.CONTACT,formData).then(response=>{
          if(response.status){
            this.setState({user_list:response.user_list, total_record : response.total_record});
          }else{
            Alert.error({title: response.message});
          }
        })
    }

    getAllGroups(){
        var department_id= localStorage.getItem('department_id');
        var formData = new FormData();
        formData.append("department_id",department_id);
        post(Constent.GETALLGROUPS,formData).then(response=>{
          if(response.status){
            this.setState({group_list:response.data});
          }else{
            Alert.error({title: response.message});
          }
        })
    }

    selectDropdown = (val) => {
        this.getUserList(val);
    };

    render() {
        const { t } = this.props;
        return (
            <Section  allNotification={false} searchPopup={true} title={t('lang.employee_sc_employee_profiles')}>
                <div className="mg-top-50">
                    
                </div>
                <div className="employeelistpage transaction-area pd-top-15 mg-bottom-40">
                    <select className="form-control" style={{background:'#E6E6E6',broder:'1px solid #CCCCCC',paddingLeft: 20}}
                    onChange={e => { this.selectDropdown(e.target.value)}}>
                    {this.state.group_list.map(({ id, group_name }) => (
                        <option value={id} key={id}>{(id === '*' ? t('lang.common_text_all_employees') : group_name ) }</option>
                    ))}
                    </select>
                    <ul className="transaction-inner" style={{marginTop:20}}>
                    {this.state.user_list.map(({ id, employee_id,job_title, first_name, last_name, username, profile_image, email,phone_no,birthday,default_language,is_finger_available,is_password,is_pin, status,alternate_number,address,city,zip,employee_date,employee_end_date,hourly_rate,salary_number,total_week_hour,personal_id_number,gender }) => (    
                        <li className="ba-single-transaction style-two" key={id}>
                            <div className="thumb">

                                <Link to={ (localStorage.getItem('user_type') !== 'user') ? '/employee-profile/'+id : '#' }>
                                <img src={profile_image} alt="img" />
                                </Link>
                            </div>
                            <div className="details" style={{marginTop: 13}}>
                                <Link to={ (localStorage.getItem('user_type') !== 'user') ? '/employee-profile/'+id : '#' }>
                                    <h5 className="text-overflow" style={{margin: 0}}>{first_name +' '+last_name}</h5>
                                    <span>{username}</span>
                                </Link>    
                                <div>
                                    <Link to={ (localStorage.getItem('user_type') !== 'user') ? '/employee-profile/'+id : '#' }>
                                        <div className="float-left text-overflow">{job_title}</div>
                                    </Link>        
                                    <div className="float-right">
                                        <Link to={'/chat/'+id} >
                                            <i className="fa fa-comments" aria-hidden="true"></i>
                                        </Link>
                                        <i className="fa fa-envelope " aria-hidden="true"></i>
                                        {phone_no.length > 0 ? 
                                            <a href="tel:{phone_no}">
                                            <i className="fa fa-phone" aria-hidden="true"></i>
                                            </a>
                                        : ''}
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}    
                    </ul>
                    
                </div>
                {/* transaction End */}
                
                {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                                <div className="col-8 offset-2">
                                    <span>{this.state.total_record} {t('lang.chat_sc_employees')}</span>
                                </div>
                                <div className="col-2">
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-home" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer End */}

                
            </Section>
        );
    }
}

export default withTranslation('common')(Employeelist);